// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1be28","form":"styles_form__36QXY"};